const products_img_url = "https://files.pipeup.ir/";

export { products_img_url };
